import { computed, unref, type Ref } from 'vue';
import { gql } from '@apollo/client/core';
import { useQuery } from '@vue/apollo-composable';
import { Query, QueryListAllUsersArgs } from '@spectee/graphql/api';
import { listAllUsers } from '@spectee/graphql/queries';

const document = gql(listAllUsers);

type QueryResult = {
  listAllUsers: Query['listAllUsers'];
};

//helper type
type UseListAllUsersAPI =
  | ReturnType<typeof useQuery<QueryResult, QueryListAllUsersArgs>>
  | ReturnType<typeof useQuery<QueryResult>>;

export function useListAllUsers(
  input: QueryListAllUsersArgs | Ref<QueryListAllUsersArgs>,
  options: {}
) {
  let API: UseListAllUsersAPI; // API an explicit type

  if (input) {
    const variables = computed(() => unref(input));

    API = useQuery<QueryResult, QueryListAllUsersArgs>(
      document,
      variables,
      options
    );
  } else {
    API = useQuery<QueryResult>(document, options);
  }
  const listAllUsersRes = computed(() => API.result.value?.listAllUsers ?? []);
  return {
    ...API,
    listAllUsersRes,
  };
}
